import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function ToolChain() {
  return (
    <section className="toolchain-serve-easy case-about-sec case-about-right">
      <Container>
        <Row className="align-items-center justify-content-between ">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-4">
            <div class="content">
              <h2>
              Toolchain We Used for <br className="d-md-block d-none"/>ServeEasy App Development
              </h2>
              <p>We utilized cutting-edge technologies, including <strong>React Native</strong> for cross-platform development, <strong>Node.js</strong> for backend scalability, <strong>AWS</strong> for cloud services, <strong>MongoDB</strong> for real-time data handling, and <strong>Stripe</strong> for secure payment processing.</p>
              <ul>
                <li>
                    <div class="icon">
                        <StaticImage
                            src="../../../images/case-studies/serve-easy/react.webp"
                            alt="The Challenge"
                            className=""
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={90}
                            height={90}
                            />
                    </div>
                    <h3>React Native</h3>
                </li>
                <li>
                    <div className="icon">
                        <StaticImage
                            src="../../../images/case-studies/serve-easy/nodejs.webp"
                            alt="The Challenge"
                            className=""
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={90}
                            height={90}
                        />
                    </div>            
                    <h3>Node.js</h3>
                </li>
                <li>
                    <div class="icon">
                        <StaticImage
                            src="../../../images/case-studies/serve-easy/aws.webp"
                            alt="The Challenge"
                            className=""
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={90}
                            height={90}
                        />
                    </div>
                    <h3>AWS</h3>
                </li>
                <li>
                    <div className="icon">
                        <StaticImage
                            src="../../../images/case-studies/serve-easy/mangoDB.webp"
                            alt="The Challenge"
                            className=""
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={90}
                            height={90}
                        />
                    </div>
                    <h3>MangoDB</h3>
                </li>
                <li>
                    <div className="icon">
                        <StaticImage
                            src="../../../images/case-studies/serve-easy/stripe.webp"
                            alt="The Challenge"
                            className=""
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={90}
                            height={90}
                        />
                    </div>
                    <h3>Stripe</h3>
                </li>
              </ul>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className=""
          >
            <div className="image text-md-end text-center position-relative d-md-block d-flex flex-column-reverse">
              <StaticImage
                src="../../../images/case-studies/serve-easy/toolchain-main.webp"
                alt="The Challenge"
                className="image-big"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={706}
                height={940}
              />
              <div class="image-small">
                  <StaticImage
                    src="../../../images/case-studies/serve-easy/toolchain-small.webp"
                    alt="The Challenge"
                    className=""
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={703}
                    height={512}
                  />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ToolChain;
